import { CountryId } from '@previo/codebooks'
import type { CountryStrategyInterface } from '~/layouts/components/l10n/countries/CountryStrategyInterface'
import { CZECountryStrategy } from '~/layouts/components/l10n/countries/CZECountryStrategy'
import { HUNCountryStrategy } from '~/layouts/components/l10n/countries/HUNCountryStrategy'
import { POLCountryStrategy } from '~/layouts/components/l10n/countries/POLCountryStrategy'
import { SVKCountryStrategy } from '~/layouts/components/l10n/countries/SVKCountryStrategy'
import { DefaultCountryStrategy } from '~/layouts/components/l10n/countries/DefaultCountryStrategy'

export function useCountryStrategy(countryId: CountryId): CountryStrategyInterface {
  switch (countryId) {
    case CountryId.CZE:
      return new CZECountryStrategy()
    case CountryId.HUN:
      return new HUNCountryStrategy()
    case CountryId.POL:
      return new POLCountryStrategy()
    case CountryId.SVK:
      return new SVKCountryStrategy()
    default:
      return new DefaultCountryStrategy()
  }
}
